import React from 'react';
import styled from 'styled-components';
import { Layout } from 'antd';
import Color from '../../../enums/color';
import NavigationSections from './NavigationSections';
import NavigationFooter from './NavigationFooter';
const StyledSider = styled(Layout.Sider) `
  background: ${Color.ElectricBlue};
  position: fixed;
  height: calc(100vh - 64px);
`;
const NavigationMenu = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
	height: 100%;
`;
const Sider = () => (<StyledSider width={200}>
    <NavigationMenu>
      <NavigationSections />
      <NavigationFooter />
    </NavigationMenu>
  </StyledSider>);
export default Sider;
